import { InputComponent, isValueComponent, ValueComponentDefinition } from "components/components/Component";
import { Dictionary, Optgroup, Option } from "components/input/select/options";
import { Renderer } from "components/Renderer";
import { ColumnDefinition } from "./columns/ColumnDefinitions";
import { ComponentColumnDefinition, isComponentColumnDefinition } from "./columns/ComponentColumn";
import { Table } from "./table";

export class ComponentCells {
    private inlineComponents = new WeakMap();

    public renderComponentCell(
        tableComponent: Table,
        columOptions: Dictionary<Array<Option | Optgroup>>,
        cd: ColumnDefinition,
        row,
        rowData: any[],
        rowIndex: number,
        index: number) {

        let renderer = Renderer.instance();
        let rendered;
        let input: InputComponent;
        if (ComponentCells.mustRenderComponent(tableComponent, cd, rowData)) {
            const definition =
                ((cd as ComponentColumnDefinition).component ?? cd.insertComponent) as ValueComponentDefinition;
            definition.property = definition.property ?? cd.property;
            input = renderer.build({ ...definition, id: definition.id + "-" + rowIndex }) as InputComponent;
            input.id = input.id + "_" + rowIndex;

            rendered = input.render();

            this.inlineComponents.set(rendered, input);
            row.children[index].innerHTML = "";
            (row.children[index] as HTMLElement).append(rendered);

            if (columOptions != null && columOptions[cd.property] != null) {
                renderer.iterateToAddOptions(input, columOptions[cd.property]);
            }
            if (isValueComponent(input) && rowData[index] != null) {
                input.value(rowData[index]);
            }
            tableComponent.restrictions.applyToComponent(input, cd);
            if (tableComponent.status.disabled) {
                input.setReadOnly(true);
            }
        }
        return input;
    }

    public static mustRenderComponent(tableComponent: Table, cd: ColumnDefinition, rowData): boolean {
        if (isComponentColumnDefinition(cd)
            && cd.editableProperty != null
            && tableComponent.getValueForFieldInRow(cd.editableProperty, rowData)) {
            return false;
        }
        return true;
    }

    public get(htmlElement: Element) {
        return this.inlineComponents.get(htmlElement);
    }

    public getRowComponents(htmlElement: Element) {
        let components = [];
        const rowElement = htmlElement.closest("tr");
        for (let cellElement of Array.from(rowElement.children)) {
            let childElement = cellElement.firstElementChild;
            if (childElement == null) {
                continue;
            }
            let component = this.inlineComponents.get(childElement);
            if (component != null) {
                components.push(component);
            }
        }
        return components;
    }

    public setAllReadOnly(htmlElement: Element, ro: boolean) {
        let cells = htmlElement.querySelectorAll("td");
        for (let cellElement of Array.from(cells)) {
            let childElement = cellElement.firstElementChild;
            if (childElement == null) {
                continue;
            }
            let component = this.inlineComponents.get(childElement) as InputComponent;
            if (component != null) {
                component.setReadOnly(ro);
            }
        }
    }
}
